module.exports = __webpack_public_path__ + "static/media/studio-blocked-popup-desktop.3f16a3a1.png";